import React from 'react';
import { useSelector } from 'react-redux';

const AndroidDashboard = () => {
  const user = useSelector((state) => state.auth.user);

  return (
    <div className="android-dashboard">
      <h1>Welcome, {user?.name}!</h1>
      <div className="android-features">
        {/* Android-specific features and UI */}
      </div>
    </div>
  );
};

export default AndroidDashboard;